import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

export const DISPLAY_SPINNER_IN_MIDDLE =
    <div style={{position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)'}}>
        <CircularProgress size={40}/>
    </div>;
